const m1 = {
  "id": "m1",
  "title": "M-Building",
  "description": {
    "bg": "Комплексът разполага с внимателно проектиран вътрешен двор, създаден като спокойно пространство за отдих и уединение. Паркирането е изцяло решено в сутеренно ниво, което осигурява тиха, подредена и хармонична жилищна среда без автомобилен трафик.\n\nБлагодарение на френските прозорци и отворената околна среда, жилищата се радват на изобилие от естествена светлина и усещане за простор. Районът се характеризира с нова инфраструктура, която допринася за комфорта и дългосрочната стойност на имота.\n\nЛокацията предлага отличен баланс между спокойствие и удобство – образователни и детски институции в близост, както и непосредствена връзка с бъдеща метростанция и спирка на градски транспорт на пешеходно разстояние. В района са разположени големи търговски вериги като Фантастико и Kaufland, както и разнообразие от магазини и услуги.\n\nС лесен и бърз достъп до Ring Mall и Business Park, комплексът осигурява удобна свързаност с ключови градски локации, съчетавайки динамиката на града с усещане за спокоен и подреден начин на живот.",
    "en": "The complex features a carefully designed inner courtyard, created as a peaceful space for relaxation and privacy. Parking is entirely solved at basement level, ensuring a quiet, orderly and harmonious residential environment without vehicular traffic.\n\nThanks to the French windows and the open surroundings, the homes enjoy an abundance of natural light and a sense of spaciousness. The area is characterized by new infrastructure that contributes to comfort and the long-term value of the property.\n\nThe location offers an excellent balance between tranquility and convenience – educational and childcare institutions nearby, as well as direct connection to a future metro station and a public transport stop within walking distance. Major retail chains such as Fantastiko and Kaufland are located in the area, along with a variety of shops and services.\n\nWith easy and quick access to Ring Mall and Business Park, the complex provides convenient connectivity to key urban locations, combining the dynamism of the city with a sense of calm and orderly living.",
    "de": "Der Komplex verfügt über einen sorgfältig gestalteten Innenhof, der als ruhiger Raum für Entspannung und Privatsphäre geschaffen wurde. Die Parkplätze sind vollständig im Untergeschoss untergebracht, was eine ruhige, geordnete und harmonische Wohnumgebung ohne Autoverkehr gewährleistet.\n\nDank der französischen Fenster und der offenen Umgebung genießen die Wohnungen reichlich natürliches Licht und ein Gefühl von Weite. Das Viertel zeichnet sich durch neue Infrastruktur aus, die zum Komfort und zum langfristigen Wert der Immobilie beiträgt.\n\nDie Lage bietet ein ausgezeichnetes Gleichgewicht zwischen Ruhe und Bequemlichkeit – Bildungs- und Kinderbetreuungseinrichtungen in der Nähe sowie direkte Anbindung an eine zukünftige U-Bahn-Station und eine Haltestelle des öffentlichen Verkehrs in Gehweite. Große Handelsketten wie Fantastiko und Kaufland sowie eine Vielzahl von Geschäften und Dienstleistungen befinden sich in der Umgebung.\n\nMit einfachem und schnellem Zugang zu Ring Mall und Business Park bietet der Komplex eine bequeme Verbindung zu wichtigen städtischen Standorten und vereint die Dynamik der Stadt mit einem Gefühl ruhigen und geordneten Lebens.",
    "ru": "Комплекс располагает тщательно спроектированным внутренним двором, созданным как спокойное пространство для отдыха и уединения. Парковка полностью решена на подземном уровне, что обеспечивает тихую, упорядоченную и гармоничную жилую среду без автомобильного движения.\n\nБлагодаря французским окнам и открытой окружающей среде жилища радуются обилию естественного света и ощущению простора. Район характеризуется новой инфраструктурой, которая способствует комфорту и долгосрочной стоимости недвижимости.\n\nРасположение предлагает отличный баланс между спокойствием и удобством — образовательные и детские учреждения поблизости, а также непосредственная связь с будущей станцией метро и остановкой общественного транспорта в пешей доступности. В районе расположены крупные торговые сети Fantastiko и Kaufland, а также разнообразие магазинов и услуг.\n\nС легким и быстрым доступом к Ring Mall и Business Park комплекс обеспечивает удобную связь с ключевыми городскими локациями, сочетая динамику города с ощущением спокойного и упорядоченного образа жизни."
  },
  "location": {
    "en": "Sofia, Malinova Dolina",
    "bg": "София, Малинова долина",
    "de": "Sofia, Malinova Dolina",
    "ru": "София, Малинова долина"
  },
  "mapData": {
    "embedUrl": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2935.1244663146554!2d23.336632!3d42.640373!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDLCsDM4JzI1LjMiTiAyM8KwMjAnMTkuOSJF!5e0!3m2!1sen!2sbg!4v1759425150348!5m2!1sen!2sbg",
    "directionsUrl": "https://maps.app.goo.gl/wL8Kfk9GZLCfWHET6",
    "coordinates": {
      "lat": 42.637496,
      "lng": 23.338983
    }
  },
  "type": "Residential Complex",
  "year": "2024",
  "status": "Act 15",
  "heroImage": "/projects/m1/IMG_1337.jpeg",
  "images": [
    "/projects/m1/IMG_1337.jpeg",
    "/projects/m1/IMG_1738.jpeg",
    "/projects/m1/IMG_1922.jpeg",
    "/projects/m1/IMG_3831.jpeg",
    "/projects/m1/IMG_4535.jpeg",
    "/projects/m1/IMG_5452.jpeg",
    "/projects/m1/IMG_7676.jpeg",
    "/projects/m1/IMG_9207.jpeg",
    "/projects/m1/IMG_9378.jpeg",
    "/projects/m1/IMG_9581.jpeg"
  ],
  "features": {
    "en": [
      "Diverse types of housing with proper forms",
      "French windows",
      "Convenient infrastructure",
      "Parking spaces and garages",
      "Gated complex",
      "Gated complex with professional property management",
      "Security system"
    ],
    "bg": [
      "Разнообразни типове жилища с правилни форми",
      "Френски прозорци",
      "Удобна инфраструктура",
      "Паркоместа и гаражи",
      "Затворен комплекс",
      "Затворен комплекс с професионален домоуправител",
      "Система за сигурност"
    ],
    "de": [
      "Verschiedene Wohnungstypen mit richtigen Formen",
      "Französische Fenster",
      "Bequeme Infrastruktur",
      "Parkplätze und Garagen",
      "Geschlossener Komplex",
      "Geschlossener Komplex mit professionellem Hausverwalter",
      "Sicherheitssystem"
    ],
    "ru": [
      "Разнообразные типы жилья с правильными формами",
      "Французские окна",
      "Удобная инфраструктура",
      "Парковочные места и гаражи",
      "Закрытый комплекс",
      "Закрытый комплекс с профессиональным управляющим",
      "Система безопасности"
    ]
  },
  "stats": {
    "area": "11,070 m²",
    "floors": "6",
    "units": "108",
    "greenAreas": "4,317 m²",
    "parkingSpaces": "117"
  },
  "availableApartments": 1
};

export default m1;
